export default "__VITE_ASSET__CADPv1H6__"